import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type SettingsPageContractViewFragment = { __typename?: 'Contract', invoiceCustomerName: string, email: string, paymentMethod: Types.PaymentMethod, isEditablePeriod: boolean, contractType: Types.ContractType };

export const SettingsPageContractViewFragmentDoc = gql`
    fragment SettingsPageContractView on Contract {
  invoiceCustomerName
  email
  paymentMethod
  isEditablePeriod
  contractType
}
    `;